export default __webpack_public_path__ + "static/media/squid-circle-icon-Black.8eebec42.png";